import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import router from './router';
import '@/styles/index.scss';
import en from '@/assets/lang/en-US.json';
import ja from '@/assets/lang/ja-JP.json';

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') ?? 'en-US',
  fallbackLocale: 'en-US',
  messages: {
    'en-US': en,
    'ja-JP': ja
  }
});

createApp(App).use(router).use(i18n).mount('#app');
